import { createSelector } from '@reduxjs/toolkit';

const selectPracticeTreatmentListSlice = (state) => state.practiceTreatmentList;
const selectTablePreferencesSlice = (state) => state.tablePreferences;
const selectLeadSlice = (state) => state.lead;
const selectPracticeTreatmentSlice = (state) => state.practiceTreatment;

// === DataGrid selectors ===
export const selectPracticeId = createSelector(
  [selectPracticeTreatmentListSlice],
  (practiceTreatmentList) => practiceTreatmentList.practiceId
);

export const selectTablePreferencesForGrid = createSelector(
  [selectTablePreferencesSlice],
  (tablePreferences) => ({
    results: tablePreferences.tablePreferences.results,
    tablePreferenceLoading: tablePreferences.tablePreferenceLoading,
    globalTablePreferences: tablePreferences.globalTablePreferences,
    practiceTablePreferences: tablePreferences.practiceTablePreferences,
  })
);

export const selectLeadLoadingStates = createSelector(
  [selectLeadSlice],
  (lead) => ({
    archivedLoading: lead.archivedLoading,
    loadingForLead: lead.loadingForLead,
    loadingForClincheckLead: lead.loadingForClincheckLead,
  })
);

export const selectChoicesData = createSelector(
  [selectPracticeTreatmentSlice],
  (practiceTreatment) => practiceTreatment.choicesData.results
);
